import Work1 from "../../assets/work1.jpg";
import Work2 from "../../assets/work2.jpg"; 
import Work3 from "../../assets/work3.jpg";
import Work4 from "../../assets/work4.jpg";
import Work5 from "../../assets/work5.jpg";

export const projectsData = [
    {
      id: 1,
      image: Work1,
      title: "EASE V1",
      category: "web",
      info:"The primary goal of the EASE V1 project is to create and deploy a comprehensive web-based ERP application for midsize companies. Developed by InApp Information Technologies Pvt Ltd, EASE V1 manages key organizational operations such as Employee Information, Business Processes, Finance, and Employee Tracking. This ERP solution aims to enhance operational efficiency, optimize resource management, and foster innovation. By integrating multiple business functions into a single, user-friendly platform, EASE V1 empowers companies to oversee and coordinate their operations effectively.",
    },
    {
      id: 2,
      image: Work2,
      title: "EASE PM Tool",
      category: "web",
      info:"The primary goal of the EASE PM Tool project is to design and implement a specialized project management application that streamlines workflows. It excels in facilitating project management, bug tracking, and generating insightful reports. Comparable to JIRA and ASANA, EASE PM Tool offers comprehensive solutions for teams and organizations, including progress monitoring, issue tracking, and detailed reporting.",
    },
    {
      id: 3,
      image: Work3,
      title: "ATS",
      category: "web",
      info:"This project aims to develop an HR application to optimize candidate hiring and job posting management. It will provide insights into interview data, hiring percentages, and candidate probabilities, streamlining HR operations. The tool will improve efficiency, reduce manual effort, and enhance decision-making with data-driven insights. The project includes design, development, testing, and deployment, making it a valuable tool for HR teams.",
    },
    {
      id: 4,
      image: Work4,
      title: "AI ChatBot",
      category: "AI",
      info: "The personalized AI chatbot is designed to recommend resources based on users' experience, knowledge, and skills. It dynamically assesses users through interactive prompts, categorizing them based on their responses, and retrieving tailored learning materials from the web. The chatbot is built using Retrieval-Augmented Generation (RAG) with Python and integrates Llama, Mistral, and Gemini APIs for enhanced response generation. A key feature is its ability to generate adaptive follow-up questions to refine user profiling, ensuring precise and effective recommendations. This AI-driven system aims to create an intelligent, user-centric learning assistant that optimizes knowledge acquisition through personalized interactions."
    }
    // {
    //   id: 5,
    //   image: Work5,
    //   title: "Web design",
    //   category: "web",
    // },
  ];
  
  export const projectsNav = [
    {
      name: "all",
    },
    {
      name: "Web",
    },
    {
      name: "AI",
    }
    // ,
    // {
    //   name: "app",
    // },
    // {
    //   name: "design",
    // },
  ];